var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.is_live)?_c('div',[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4"},[_c('statistics-card-line',{staticClass:"mb-base",attrs:{"hideChart":"","icon":"HomeIcon","icon-right":"","statistic":"7","statisticTitle":"Total Tenants"}})],1)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }